module.exports = __webpack_public_path__ + "img/avaliacoes.e737ac83.svg";